// Enable Promises, Generators, and Array.prototype methods in IE
import 'babel-polyfill';

import endpoints from './constants/endpoints';
import widgetConstructors from './constants/widgets';

import Widget from './classes/widget';

import { request } from '../shared/utilities';

(function () {
	const loader = load();
	const fetchWidgets = loader.next().value;

	fetchWidgets
		.then(response => loader.next(response.data))
		.catch(error => console.error(error));

	/**
	 * @function load
	 * Synchronously fetch widget data and render templates.
	 * @return {Generator}
	 */
	function* load () {
		let widgets = yield request(endpoints.FETCH_SAVED_WIDGETS, true);

		widgets.forEach(data => {
			if (data.isComplete) {
				let Constructor = widgetConstructors[data.type];

				let widget = Constructor ? new Constructor(data) : new Widget(data);

				widget.render();
			}
		});
	}
})();



// WEBPACK FOOTER //
// ./src/main/webapps/features/stickybins/scripts/public/client.js